<template>
  <div class="judge-main">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.judge-main {
  height: 100vh;
  width: 100%;
  max-width: 10rem;
}
</style>
